import imageWhite from './map-cluster.png'
import imageBlack from './map-cluster-black.png'

export const dimensions = {
  height: 55,
  width: 55,
}

export const styles = {
  white: {
    ...dimensions,
    textColor: 'black',
    url: imageWhite,
  },
  black: {
    ...dimensions,
    textColor: 'white',
    url: imageBlack,
  },
}
